var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('iframe',{staticClass:"hide-scrollbar",staticStyle:{"width":"100%","border":"none","height":"100%"},attrs:{"srcdoc":_vm.srcdoc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }